/** @format */
export const ACTIONS = {
  SHOW_LOGIN_POPUP: "SHOW_LOGIN_POP_UP",
  SHOW_ADMIN_LOGIN_POPUP: "SHOW_ADMIN_LOGIN_POP_UP",
  SHOW_SIGNUP_POPUP: "SHOW_SIGNIN_POP_UP",
  HIDE_POPUP: "HIDE_POP_UP",
  SET_CURRENT_USER: "CURRENT_USER",
  SET_TOAST_SUCCESSFULL: "SET_TOAST_SUCCESSFULL",
  SET_TOAST_FAILURE: "SET_TOAST_FAILURE",
  SET_TOAST_NULL: "SET_TOAST_NULL",
  SET_TOAST_TRUE: "SET_TOAST_TRUE",
};

export const authReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SHOW_LOGIN_POPUP:
      return {
        ...state,
        loginPopupState: true,
        signupPopupState: false,
        adminLoginPopupState: false,
      };
    case ACTIONS.SHOW_ADMIN_LOGIN_POPUP:
      return {
        ...state,
        loginPopupState: false,
        signupPopupState: false,
        adminLoginPopupState: true,
      };
    case ACTIONS.SHOW_SIGNUP_POPUP:
      return {
        ...state,
        loginPopupState: false,
        signupPopupState: true,
        adminLoginPopupState: false,
      };
    case ACTIONS.HIDE_POPUP:
      return {
        ...state,
        loginPopupState: false,
        signupPopupState: false,
        adminLoginPopupState: false,
      };

    case ACTIONS.SET_CURRENT_USER:
      const activeUser = action.payload;
      return {
        ...state,
        currentUser: activeUser,
      };

    case ACTIONS.SET_TOAST_SUCCESSFULL:
      return {
        ...state,
        ...state.toastObject,
        toast: true,
        toastText: "SUCCESSFULL",
        toastBg: "#11e61190",
      };

    case ACTIONS.SET_TOAST_FAILURE:
      return {
        ...state,
        ...state.toastObject,
        toast: true,
        toastText: "FAILURE! Something went wrong...",
        toastBg: "#ff1e1ec1",
      };

    case ACTIONS.SET_TOAST_NULL:
      return {
        ...state,
        // ...state.toastObject,
        toast: null,
      };

    default:
      return state;
  }
};
